module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0063.jpg?v=3c83aaac";